import { atom } from 'jotai';

import type { components } from '@/types/openapi';

export type SyncDevicesDialogMode =
  | 'newSyncDevices'
  | 'confirmSyncDevices'
  | 'viewSyncInProgress';

export const statusCodeDialogOpenAtom = atom(false);
export const statusCodeDialogModeAtom =
  atom<SyncDevicesDialogMode>('newSyncDevices');
export const groupeddevicesSyncDataAtom = atom<GroupedDevicesSyncData[]>([]);
export const groupedSyncItemsAtom = atom<GroupedDevicesSyncData[]>([]);

export type DeviceSyncDataDTO = components['schemas']['DeviceSyncData'];
export type DeviceListingResponseDTO =
  components['schemas']['DeviceListingResponse'];
export type LimaSourceAggregatedStatusDTO =
  components['schemas']['LimaSourceAggregatedStatus'];

export type LimaSourceAggregatedStatusModel = LimaSourceAggregatedStatusDTO & {
  status?: string;
  last_seen_display?: string;
  group_1xxx?: number;
  group_2xxx?: number;
  group_3xxx?: number;
  group_4xxx?: number;
  group_null?: number;
  highest_status_code?: number | null;
  highest_status?: string;
  color?: string;
  statusGroups?: StatusGroup[];
  status_label?: string;
  source_count?: number;
};

export type StatusGroup = {
  label: string;
  sourceCount: number;
  codePrefix: string;
  color: string;
};

export type DeviceSyncDataModel = DeviceSyncDataDTO & {
  isSelected?: boolean;
  isSyncInProgress?: boolean;
  actionType?: string;
  orgName?: string;
  hostName?: string;
};

export type DeviceSyncPostDTO = components['schemas']['DeviceSyncRequest'];

export interface DeviceSyncFormProps {
  orgName?: string;
  items?: DeviceSyncDataModel[];
  index?: number;
}

export type GroupedDevicesSyncData = {
  organization?: string;
  items?: DeviceSyncDataModel[];
  selectedCount?: number;
};

export type syncDevicesPayload = {
  device_hosts: string[];
};

export type DeviceSyncCreateDTO = {
  host_name?: string;
  device_uid?: string;
  customer_id?: string;
  device_type?: string;
  new_config?: string;
  new_device_size?: string;
  old_device_size?: string;
  old_config?: string;
};

export type DeviceDiffModel = {
  device_size?: string;
  configuration?: string;
};

export type DeviceDiffViewerProps = {
  host_name?: string;
  prod_device_size?: string | null;
  prod_configuration?: string | null;
  device_size?: string | null;
  configuration?: string | null;
  action_type?: string;
};

export type DeviceSyncRowProps = {
  host_name?: string;
  action_type?: string;
  device_type?: string;
};
export type DeviceAccordionRowProps = {
  deviceRow: DeviceSyncDataModel;
};
